import { useState, useEffect, useRef } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children }) {
  const { user, loading, refreshUser } = useAuth();
  const location = useLocation();
  const [checking, setChecking] = useState(false);
  const checkedRef = useRef(false);

  useEffect(() => {
    // If auth is done loading, user is null, and we haven't checked yet
    if (!loading && !user && !checkedRef.current) {
      const token = localStorage.getItem("session_token");
      if (token) {
        checkedRef.current = true;
        setChecking(true);
        refreshUser().finally(() => setChecking(false));
      }
    }
  }, [loading, user, refreshUser]);

  if (loading || checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="loading-screen">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!user.onboarding_completed && location.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
